import { useTranslation } from "@redotech/redo-i18n";
import { memo, type ReactNode } from "react";
import { NavigationMoveCallout } from "../navigation-move-callout";

export const DocumentsNavigationCallout = memo(
  function DocumentsNavigationCallout({ children }: { children: ReactNode }) {
    const { t } = useTranslation();
    return (
      <NavigationMoveCallout
        anchorSelector=':scope > [data-arbiter="RedoSecondaryNavItem"] > button'
        description={t(
          "Manage packing slips, personalized inserts, pick lists, and shipping labels in one place.",
        )}
        dismissOnVisit={false}
        dismissText={t("Got it")}
        expiresAt={new Date(2026, 10, 16).getTime()}
        storageKey="redo.shipping-documents.callout-seen"
        title={t("Documents have moved")}
      >
        {children}
      </NavigationMoveCallout>
    );
  },
);
